import {
  type LocalPreferenceAction,
  localPreferenceActions,
  type LocalPreferenceState
} from '../context';

export const localPreferenceReducer = (
  state: LocalPreferenceState,
  action: LocalPreferenceAction
) => {
  let updatedState = state;
  switch (action.type) {
    case localPreferenceActions.initializePreference:
      updatedState = { ...state, ...action.payload };
      break;
    case localPreferenceActions.updatedLocalPreference: {
      const { updatedSettings } = action.payload;

      updatedState = {
        ...state,
        ...updatedSettings
      };
      break;
    }
    case localPreferenceActions.setMuteVideo:
      updatedState = { ...state, muteVideo: action.payload };
      break;
    case localPreferenceActions.SET_THEME:
      updatedState = { ...state, theme: action.payload };
      break;
    default:
      return state;
  }
  return updatedState;
};
